import * as React from 'react';

import {EligibleForBonusReportContent} from '/component/partial/reportCard/EligibleForBonusReportContent';
import {useTranslation} from '/provider/TranslationProvider';

interface OrderingEntities {
  clients: any[];
  currentCount: number;
  target: number;
}

interface RecordData {
  cabFQV: number;
  newOrderingEntitiesCount: number;
  cabRemainingEligibility: number;
  orderingEntities: OrderingEntities;
}

interface EligibleForCabReportContentProps {
  recordData: RecordData;
}

export const EligibleForCabReportContent: React.FC<
  EligibleForCabReportContentProps
> = ({
  recordData = {
    cabFQV: 0,
    newOrderingEntitiesCount: 0,
    cabRemainingEligibility: 0,
    orderingEntities: {clients: [], currentCount: 0, target: 0},
  },
}) => {
  const {
    cabFQV,
    newOrderingEntitiesCount,
    cabRemainingEligibility,
    orderingEntities,
  } = recordData;

  const {ts} = useTranslation('reportCardContent.eligibleForCab');
  const reportCardData = {
    orderingEntities,
    fqv: cabFQV,
    newOrderingEntitiesCount,
    remainingEligibility: cabRemainingEligibility,
  };
  return (
    <EligibleForBonusReportContent
      title={ts('heading', 'Eligible for Client Acquisition Bonus')}
      orderingEntitiesName={ts(
        'label.cabOrderingEntities',
        'CAB Ordering Entities',
      )}
      fqvName={ts('label.cabFqv', 'CAB Frontline Qualifying Volume')}
      recordData={reportCardData}
    />
  );
};
